// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","button__outlined":"Button_button__outlined__J-qrE"};